import React from "react";
import { ApplicationState } from "../store";
import { connect, ConnectedProps } from "react-redux";

import BankAccountClearingNumberInput from "./BankAccountClearingNumberInput";
import BankAccountNumberInput from "./BankAccountNumberInput";
import BankAccountOwnerNameInput from "./BankAccountOwnerNameInput";
import BankAccountOwnerSSNInput from "./BankAccountOwnerSSNInput";
import BankAccountOwnerCheckbox from "./BankAccountOwnerCheckbox";
import { BrandsEnum } from "../enums";
import clsx from "clsx";

const connector = connect((state: ApplicationState) => state, {});
type BankAccountInputsSectionProps = ConnectedProps<typeof connector> & { inputClass?: string };

const BankAccountInputsSectionComponet: React.FC<BankAccountInputsSectionProps> = (props: BankAccountInputsSectionProps) => {
  if (!props.payment?.inputs) {
    return <React.Fragment />;
  }

  const isCommercialBrand = props.inputs.brand === BrandsEnum.PolestarForetag || props.inputs.brand === BrandsEnum.VolviaForetag;

  return (
    <React.Fragment>
      <BankAccountClearingNumberInput inputClass={clsx(props.inputClass)} />
      <BankAccountNumberInput inputClass={clsx(props.inputClass)} />
      {!isCommercialBrand && <BankAccountOwnerCheckbox />}
      {props.payment?.inputs?.bankAccountOwner?.notOwner && (
        <React.Fragment>
          <BankAccountOwnerNameInput inputClass={clsx(props.inputClass)} />
          <BankAccountOwnerSSNInput inputClass={clsx(props.inputClass)} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export const BankAccountInputsSection = connector(BankAccountInputsSectionComponet);
